
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.253 14.751H14.751a9.249 9.249 0 106.604 15.723h5.29a9.249 9.249 0 106.608-15.723zm-13.415 9.943c0 .383-.31.693-.694.693h-3.006v3.006c0 .383-.31.694-.693.694h-1.388a.694.694 0 01-.693-.694v-3.006h-3.006a.694.694 0 01-.694-.693v-1.388c0-.383.31-.693.694-.693h3.006v-3.006c0-.383.31-.694.693-.694h1.388c.383 0 .693.31.693.694v3.006h3.006c.383 0 .694.31.694.693v1.388zm12.486 4.393a2.312 2.312 0 110-4.625 2.312 2.312 0 010 4.625zm3.7-5.55a2.312 2.312 0 110-4.624 2.312 2.312 0 010 4.624z","fill":"#535353"}})])
          )
        }
      }
    